 /* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Byline from '~components/base/Bylines';


import '~styles/modules/topper.scss';

const Topper = ({ hed,subhed,byline,pubDate }) => (
  <div className="topper main-header">
  	<div className="hed-container">
  		<div className="headline">THE HATE WE GIVE</div>
  		<div className="subheadline">{subhed}</div>

      <div class="byline-container">
        <div className="byline">By <a href='https://www.bostonglobe.com/about/staff-list/staff/jenee-osterheldt/'>Jeneé Osterheldt</a> Globe Columnist</div>
        <div className="byline"> Design and development: <a href='https://www.bostonglobe.com/about/staff-list/staff/vince-dixon/'>Vince Dixon</a> | Photography: Christiana Botic and Jessica Rinaldi</div>
        <div className="byline"> February 25, 2022</div>

        <div className="pubdate">{pubDate}</div>



      </div>



    </div>
    
  </div>
);

Topper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Topper;
